import controller from './client-selector-controller';
import template from './client-selector.html'

/***
 * A page that allows a user to select one or more clients (with client name sorting and filtering). There is a
 * large button at the top of the page that can be given an onButtonClick callback.
 */
const ClientSelectorComponent = {
    bindings: {
        buttonText: '<',
        clientList: '<',
        onButtonClick: '&'
    },
    controller,
    template,
};

export default ClientSelectorComponent;



// WEBPACK FOOTER //
// ./app/common/client-selector/client-selector-component.js